import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import { Divider } from '@mui/material';

import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
// import EastIcon from '@mui/icons-material/East';

const names = [
  'Ubuntu 18.04',
  'Windows 11',
  'Linux'
];

const ITEM_HEIGHT = 68;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 550,
    },
  },
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "35vw",
  bgcolor: '#242424',
  boxShadow: 24,
  p: 4,
};

export default function AssignToTemplateModal() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [imageName, setImageName] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setImageName(
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  return (
    <div>
      <IconButton aria-label="share" sx={{ color: 'lightgray' }}>
        <Tooltip
          title="Assign to Template"
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: 'lightgray',
                color: 'black',
                fontSize: '0.9rem',
              },
            },
          }}
        >
          <IconButton sx={{ color: 'lightgray' }}>
            <LibraryAddIcon onClick={handleOpen} />
          </IconButton>
        </Tooltip>
      </IconButton>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "lightgray", fontWeight: "900" }}>
            Assign to Template
          </Typography>
          <Divider sx={{ backgroundColor: 'lightgray', margin: "2rem 0" }} />
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <FormControl sx={{ m: 1, width: 300 }}>
                <InputLabel id="demo-multiple-checkbox-label" sx={{
                  color: 'lightgray',
                  '&.Mui-focused': {
                    color: 'lightgray',
                  }
                }}>Image</InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  multiple
                  value={imageName}
                  onChange={handleChange}
                  input={<OutlinedInput label="Image" />}
                  renderValue={(selected) => (
                    <span style={{ color: 'lightgray' }}>{selected.join(', ')}</span>
                  )}
                  MenuProps={MenuProps}
                  sx={{
                    color: 'lightgray',
                    '.MuiOutlinedInput-notchedOutline': {
                      borderColor: 'gray',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'gray',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'gray',
                    },
                  }}
                >
                  {names.map((name) => (
                    <MenuItem key={name} value={name}>
                      <Checkbox
                        checked={imageName.includes(name)}
                        sx={{
                          color: 'lightgray',
                          '&.Mui-checked': {
                            color: 'lightgray',
                          },
                        }}
                      />
                      <ListItemText primary={name} sx={{ color: 'lightgray' }} />
                    </MenuItem>
                  ))}
                </Select>

              </FormControl>

              <Button
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                // startIcon={'Assign'}
                sx={{
                  width: "12rem",
                  backgroundColor: 'transparent',
                  border: "1px solid gray",
                  color: 'white',
                  '&:hover': {
                    backgroundColor: 'transparent',
                  },
                  height: "55px",
                  display: "flex",
                  alignItems: "center"
                }}
              >
                Assign
              </Button>
            </div>
          </Typography>

        </Box>
      </Modal>
    </div >
  );
}

